import React, {useState, useEffect} from 'react';
import GridLayout from 'react-grid-layout';
import '../css/GUIInstrumentGrid.css';
import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import GUIInstrumentRow from "../gridcomponents/guiinstrumentrow/GUIInstrumentRow";
import Button from '@mui/material/Button';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import {fetchGUIInstrumentsByTabID} from '../../services/GUIInstrumentService';  // You need to implement this function

const DefaultGridComponent = () => {


    return (
        <div className="resizable-container">
            <div className="layout-wrapper">

                    <div key={1000} className="error-grid-item" style={{ textAlign: 'center' }}>
                        <div className="ERROR">
                            ERROR
                        </div>
                    </div>
            </div>
        </div>
    );
};

export default DefaultGridComponent;
